import { all } from 'redux-saga/effects';
import { watcherPostsActions } from './postsSaga';
import { watcherSearchActions } from './searchSaga';
import { watcherSettingsActions } from './settingsSaga';
import { watcherBasketActions } from './basketSaga';

export default function* rootSaga() {
    yield all([
        watcherPostsActions(),
        watcherSearchActions(),
        watcherSettingsActions(),
        watcherBasketActions()
    ]);
}